import {
  Box, Flex,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverHeader,
  PopoverBody,
  Portal,
} from "@chakra-ui/react";
import LaunchdeckTag from "../../global/components/helper-components/components/LaunchdeckTag";
import { LuFlag } from "react-icons/lu";
import { displayReactIcon } from "../helpers/dsr-display-helpers";
import { getThisUserIdToken, isValidArray } from "../../global/helpers/global-helpers";
import { getUserDetailsUsingDsrMembersArray } from "../../profile/helpers/user-helper";
import { useEffect, useState } from "react";
import { formatDisplayLocalDateTime } from "../../global/helpers/time-format-helpers";

function PostReplyButtonModule({
  allowSliding,
  flaggedRepliesReports,
  isDsrAdmin,
  dsrTeamMembers,
  // isAuthor,
  // isStaticMode,
  //
  children
}) {
  
  const [showFlag, setShowFlag] = useState(null)
  const [displayedReport, setDisplayedReport] = useState(null)
  const [totalReportsDisplay, setTotalReportsDisplay] = useState(0)


  // Manage case for DSR Admin
  useEffect(() => {
    if (isValidArray(flaggedRepliesReports) && isDsrAdmin && dsrTeamMembers) {
      setShowFlag(true)

      const thisUserIdToken = getThisUserIdToken();
      const latestReport = flaggedRepliesReports?.at(-1);
      const totalReports = flaggedRepliesReports?.length;
      const foundMember = getUserDetailsUsingDsrMembersArray(dsrTeamMembers, thisUserIdToken)
      const { memberName, email } = foundMember || {}
      const displayedReport = {
        ...latestReport,
        reporterName: memberName ? memberName : email
      }

      setDisplayedReport(displayedReport)
      setTotalReportsDisplay(totalReports > 1 ? totalReports - 1 : 0)

    } else {
      setShowFlag(false)
    }
  }, [flaggedRepliesReports && isDsrAdmin && dsrTeamMembers])

  // Manage case for members to report
  


  if (showFlag) {
    const { reporterName, dateReported, reportReason } = displayedReport || {}
    return (
      <Flex
        gap="0.5em"
        justify="flex-end"
        align="center"
        position="relative"
      >
        <Popover isLazy trigger="hover" placement='bottom'>
          <PopoverTrigger>
            <Box
              transform={allowSliding ? "translateX(-40px)" : "translateX(0)"}
              transition="transform 0.3s ease-in-out"
              bg="inherit" 
              // 'white'
              zIndex='60'
            >
              <LaunchdeckTag bg='brandPink.500' color='white'>
                <Flex align='center' justify='center' gap='0.5em'>
                  <LuFlag />
                </Flex>
              </LaunchdeckTag>
            </Box>
          </PopoverTrigger>
          <Portal>
            <PopoverContent minW='25em' bg='brandDark.500'>

              <PopoverHeader fontWeight='600' fontSize='0.875em' color='brandPink.500' p='0.5em 1em'>
                <Flex justify='flex-start' align='center' gap='0.5em'>{displayReactIcon('alert', '1em')} <Box>Flagged post</Box></Flex>
              </PopoverHeader>

              <PopoverBody p='1em'>
                <Box w='100%' color='white'>
                  <Flex fontSize='0.875em' color='white' fontWeight='600'>
                    What happened?
                  </Flex>
                  <Flex mt='0.5em' fontSize='0.875em' justify='flex-start' textAlign='left' fontStyle='italic'>
                    {reportReason}
                  </Flex>
                  <Flex mt='0.2em' fontSize='0.7em' fontWeight='600' color='white'>
                    {reporterName}
                  </Flex>
                  <Flex mt='0.25em' fontSize='0.7em' justify='flex-start' textAlign='left'>
                    {formatDisplayLocalDateTime(dateReported)}
                  </Flex>

                  {totalReportsDisplay > 0 &&
                    <>
                      <Flex mt='2em' fontSize='0.875em' color='white' fontWeight='600'>
                        Note
                      </Flex>
                      <Flex fontSize='0.7em' justify='flex-start' textAlign='left'>
                        This has also been reported by {totalReportsDisplay} other user(s)
                      </Flex>
                    </>
                  }

                  <Flex mt='1.5em' fontSize='0.875em' fontWeight='600' color='brand.500'>
                    Next steps
                  </Flex>
                  <Flex mt='0.5em' fontSize='0.75em' justify='flex-start' textAlign='left' color='gray.50'>
                    If you agree that it's inappropriate, consider deleting it. Meanwhile, it'll remain hidden for those who had reported it.
                  </Flex>
                </Box>
              </PopoverBody>

            </PopoverContent>
          </Portal>
        </Popover>

        <Box
          opacity={allowSliding ? 1 : 0} // Fade in/out based on condition
          visibility={allowSliding ? "visible" : "hidden"} // Ensure it's not interactable when invisible
          position="absolute" // Keep it positioned correctly
          right="0"
          transition="opacity 0.3s ease-in-out, visibility 0s linear 0s" // No delay on opacity when fading out
          _group={{
            opacity: 0, // Initially hidden
            visibility: "hidden", // Initially hidden
            transition: "opacity 0.3s ease-in-out 0.3s" // Delay the fade-in when hovered in
          }}
          _groupHover={{
            opacity: 1, // Fades in on hover
            visibility: "visible", // Become visible
            transition: "opacity 0.3s ease-in-out, visibility 0s linear 0s" // Delay visibility transition
          }}
        >
          {children}
        </Box>
      </Flex>
    )
  } else {
    return (
      <Box
        opacity={allowSliding ? '1.0' : '0'}
        transition="opacity 0.2s ease-in-out"
      >
        {children}
      </Box>
    )
  }
}


export default PostReplyButtonModule